<template>
  <form id="search-bar" class="w-full max-w-3xl mx-auto my-10 px-5" @submit="$event.preventDefault()">
    <div class="flex border-2 border-solid border-[black] rounded-xl has-focus-within:border-(--main-color)">
      <input
        type="search"
        name="search_string"
        id="search_string"
        class="w-full h-12 px-4 text-lg outline-none"
        :placeholder="$t('search')"
        @input="event => $emit('update:modelValue', (event.target as HTMLInputElement).value.trim())" />
      <button type="reset" class="hover:cursor-pointer px-3" @click="$emit('update:modelValue', '')">
        <IconSprite v-if="$props.modelValue" id="erase" class="text-2xl" />
      </button>
    </div>
  </form>
</template>
<script lang="ts">
import IconSprite from "@/components/helpers/IconSprite.vue"

export default {
  name: "SearchBar",
  components: {IconSprite},
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
}
</script>
